import { render, staticRenderFns } from "./infomation.vue?vue&type=template&id=fcd11ed4&scoped=true&"
import script from "./infomation.vue?vue&type=script&lang=js&"
export * from "./infomation.vue?vue&type=script&lang=js&"
import style0 from "./infomation.vue?vue&type=style&index=0&id=fcd11ed4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd11ed4",
  null
  
)

export default component.exports